<template>
  <li class="nav-item">
    <router-link :class="classes" :to="destination"
      >{{ label }} <span v-if="count !== undefined">({{ count }})</span></router-link
    >
  </li>
</template>

<script>
export default {
  name: 'LeadlikeTabLink',
  props: {
    routeName: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: false,
    },
    label: { type: String, required: true },
  },
  computed: {
    destination() {
      return { name: this.routeName, params: { id: this.id } };
    },
    classes() {
      return { 'nav-link': true, active: this.$route.name === this.routeName };
    },
  },
};
</script>

<style lang="scss" scoped></style>
